export default "__VITE_ASSET__fdc6ae1b__"